export const COLOR_PRIMARY = "#282c34" // React blue/grey
export const COLOR_SECONDARY = "#f2f3f0" // Almost white
export const COLOR_TERTIARY = "#c0c8cc" // Map background / blue / grey
export const COLOR_ACCENT_PRIMARY = "#53A548"
export const COLOR_ACCENT_SECONDARY = "#ffa057"
export const COLOR_WHITE = "white"
